export default __webpack_public_path__ + "static/media/asan.0ff40509.png";